module.exports = __webpack_public_path__ + "static/efranklin_Frontend Developer_2022-84972365f2476cb55e79987ed37f8388.pdf";